import api from '../api';

export interface UploadPhotoArgs {
  file: File; entity_type: string; entity_id: number; sub_type: string;
  notes?: string; visibility?: 'internal' | 'customer';
}

export const attachmentExtensionsApi = {
  uploadPhoto: async ({ file, entity_type, entity_id, sub_type, notes, visibility }: UploadPhotoArgs) => {
    const form = new FormData();
    form.append('file', file);
    form.append('entity_type', entity_type);
    form.append('entity_id', String(entity_id));
    form.append('sub_type', sub_type);
    if (notes) form.append('notes', notes);
    if (visibility) form.append('visibility', visibility);
    const { data } = await api.post('/attachments', form);
    return data;
  },
  listByEntity: async (entity_type: string, entity_id: number, sub_type?: string) => {
    const params: any = { entity_type, entity_id };
    if (sub_type) params.sub_type = sub_type;
    const { data } = await api.get('/attachments', { params });
    return data;
  },
  reassign: async (id: number, entity_type: string, entity_id: number) => {
    const { data } = await api.patch(`/attachments/${id}/assign`, { entity_type, entity_id });
    return data;
  },
  delete: async (id: number) => { await api.delete(`/attachments/${id}`); },
  setVisibility: async (id: number, visibility: 'internal' | 'customer') => {
    const { data } = await api.put(`/attachments/${id}/visibility`, { visibility });
    return data;
  },
};
